<template>
  <el-dialog
    :visible="visible"
    class="dialogGroup choose_device"
    :before-close="handlerClose"
    :modal-append-to-body="false"
  >
    <op-device-choose
      ref="opDeviceChoose"
      :is_group="is_group"
      :areaid="gpNo"
      :area-tree-type="areaTreeType"
      :execute-type="executeType"
      :displaynoarea="displaynoarea"
      :triggledevice="triggledevice"
      :is-ifttt="isIfttt"
      :checkeddata="checkeddata"
      :child-category-type="childCategoryType"
      :is-need-same-device-status="isNeedSameDeviceStatus"
      :is-sence="isSence"
      :is-visual="isVisual"
      :multiple-dialog-group="multipleDialogGroup"
      @confirm="deviceValueChange"
      @chooseDeviceInMap="chooseDeviceInMap"
    />
  </el-dialog>
</template>

<script>
// import OpDeviceChoose from '@/components/common/OpDeviceChoose.vue';
import { alertsuccess, warning } from '@/assets/js/common.js';

export default {
  components: {
    // OpDeviceChoose,
  },
  props: {
    is_group: {
      type: Boolean,
      default: true
    },
    visible: {
      type: Boolean,
      default: false
    },
    executeType: {
      type: Number,
      default: 1
    },
    areaTreeType: {
      type: Number,
      default: 1
    },
    triggledevice: {
      type: Boolean,
      default: true
    },
    displaynoarea: {
      type: Boolean,
      default: true
    },
    // eslint-disable-next-line vue/prop-name-casing
    gpNo: {
      type: Number,
      default: -1
    },
    isSameClassSku: {
      type: Boolean,
      default: true
    },
    childCategoryType: {
      type: String,
    },
    isNeedSameDeviceStatus: {
      type: Number,
      default: 0,
    },
    checkeddata:  {
      type: Array,
      default: () => []
    },
    isSence: {
      type: Boolean,
      default: false
    },
    isIfttt: {
      type: Boolean,
      default: true
    },
    isVisual: {
      type: Boolean,
      default: false
    },
    // 自动化选中设备不过滤,并且卡片标上已选状态
    multipleDialogGroup:{
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      deviceValue: [],
    }
  },
  watch: {
    visible(val) {
      if (!val) return;
      
      this.$refs.opDeviceChoose && this.$refs.opDeviceChoose.refresh && this.$refs.opDeviceChoose.refresh()
    }
  },

  created () {

  },
  methods: {
    chooseDeviceInMap(deviceList){
      console.log("🚀 ~ chooseDeviceInMap ~ deviceList:", deviceList)
      this.$emit('chooseDeviceInMap',deviceList);
    },
    deviceValueChange(deviceList) {
      this.deviceValue = deviceList;
      if (this.is_group) {

        this.$emit('change', deviceList[0]);

        this.handlerClose();

        return;
      }


      if (this.isSameClassSku) {
        const firstItem = deviceList[0];
        const firstClassSku = firstItem.ClassSku;
        const notSameItem = deviceList.find(item => item.ClassSku !== firstClassSku);

        if (!!notSameItem) {
          this.$message({
            message: this.$t('ifttt.chooseSame'),
            type: 'warning'
          });

          return;
        }
      }

      this.$emit('change', deviceList);

      this.handlerClose();
      
      // 
    },

    delmanualTrigger (item, index) {
      // if (this.iftttmodel) {
      //   if (!this.iftttmodel.IsManual) {
      //     this.triggermanual.splice(index, 1);
      //     alertsuccess(this, this.$store.state.rightStatusCode);
      //     this.drowisdisabled()
      //   } else {
      //     warning(this, this.$t('iftttset.handlewarning'))
      //   }
      // } else {
      //   this.triggermanual.splice(index, 1);
      //   alertsuccess(this, this.$store.state.rightStatusCode);
      //   this.drowisdisabled();
      // }
    },

    getDeviceValue() {
      return this.deviceValue;
    },

    // 关闭弹窗
    handlerClose() {
      // this.timeValue = null;

      this.$emit('close');
    },
  }
}
</script>

<style lang="scss" scoped>
.choose_device  ::v-deep .ly-tree-container .ly-tree-container-tance .el-tree-node__content:hover .tree_count{
  display: block;
}

</style>
